class FileDrop extends HTMLElement {
  connectedCallback() {
    this.depth = 0;
    this.addEventListener("dragenter", this.onEnter);
    this.addEventListener("dragover", this.onOver);
    this.addEventListener("dragleave", this.onLeave);
    this.addEventListener("drop", this.onDrop);
  }

  disconnectedCallback() {
    this.removeEventListener("dragenter", this.onEnter);
    this.removeEventListener("dragover", this.onOver);
    this.removeEventListener("dragleave", this.onLeave);
    this.removeEventListener("drop", this.onDrop);
  }

  usable() {
    return this.hasAttribute("droppable");
  }

  onEnter = (event) => {
    if (!this.usable()) return;
    event.preventDefault();
    this.depth += 1;
    this.setAttribute("dragging", "");
  };

  onOver = (event) => {
    if (!this.usable()) return;
    event.preventDefault();
  };

  onLeave = () => {
    this.depth = Math.max(0, this.depth - 1);
    if (this.depth === 0) this.removeAttribute("dragging");
  };

  onDrop = () => {
    this.depth = 0;
    this.removeAttribute("dragging");
  };
}

customElements.define("file-drop", FileDrop);
